/** Ticket QR payload helpers. Keep this as the single source of format. */

export interface TicketPayload {
  v: 1;
  e: string; // event_id
  g: string; // event_guests.id
}

export const encodeTicket = (eventId: string, guestId: string): string =>
  JSON.stringify({ v: 1, e: eventId, g: guestId } satisfies TicketPayload);

export const decodeTicket = (raw: string): TicketPayload | null => {
  try {
    const trimmed = raw.trim();
    if (!trimmed.startsWith("{")) return null;
    const parsed = JSON.parse(trimmed) as Partial<TicketPayload>;
    if (parsed?.v !== 1 || !parsed.e || !parsed.g) return null;
    return parsed as TicketPayload;
  } catch {
    return null;
  }
};
